import { render, staticRenderFns } from "./ScheduleAddBooking.vue?vue&type=template&id=60c4f1a4"
import script from "./ScheduleAddBooking.vue?vue&type=script&lang=js"
export * from "./ScheduleAddBooking.vue?vue&type=script&lang=js"
import style0 from "./ScheduleAddBooking.vue?vue&type=style&index=0&id=60c4f1a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports